import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-17616d18"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "d-flex justify-content-center" }, [
    /*#__PURE__*/ _createElementVNode("h5", { class: "mt-n3 mb-1 text-dark" }, "Cadastro")
], -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-center" }, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/login",
        class: "text-muted",
        style: { "text-decoration": "underline" }
    }, "Já tem conta? Faça Login"),
    /*#__PURE__*/ _createElementVNode("br"),
    /*#__PURE__*/ _createTextVNode(" Ou preencha o formulário abaixo. ")
], -1));
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-12" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CPF/CNPJ", -1));
const _hoisted_7 = {
    key: 0,
    class: "row"
};
const _hoisted_8 = { class: "col-12" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Nome Completo", -1));
const _hoisted_10 = { class: "col-6" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Data Nascimento", -1));
const _hoisted_12 = { class: "col-6" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Celular", -1));
const _hoisted_14 = {
    key: 1,
    class: "row"
};
const _hoisted_15 = { class: "col-12" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Razão Social", -1));
const _hoisted_17 = { class: "col-6" };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "IE", -1));
const _hoisted_19 = { class: "col-6" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Celular", -1));
const _hoisted_21 = { class: "col-12" };
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("legend", null, "Dados do Responsável pela PJ", -1));
const _hoisted_23 = { class: "row" };
const _hoisted_24 = { class: "col-12" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Nome Completo", -1));
const _hoisted_26 = { class: "col-6" };
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Data Nascimento", -1));
const _hoisted_28 = { class: "col-6" };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "CPF", -1));
const _hoisted_30 = { class: "row" };
const _hoisted_31 = { class: "col-12" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "E-mail", -1));
const _hoisted_33 = { class: "col-12" };
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Confirma E-mail", -1));
const _hoisted_35 = { class: "row" };
const _hoisted_36 = { class: "col-6" };
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, [
    /*#__PURE__*/ _createTextVNode("Senha "),
    /*#__PURE__*/ _createElementVNode("i", {
        class: "fa fa-info-circle",
        title: "A senha deve ter no mínimo 6 caracteres"
    })
], -1));
const _hoisted_38 = { class: "col-6" };
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "requerido" }, "Confirme a Senha", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DocumentoInput = _resolveComponent("DocumentoInput");
    const _component_DatetimePicker = _resolveComponent("DatetimePicker");
    const _component_InputMasked = _resolveComponent("InputMasked");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_DocumentoInput, {
                    modelValue: _ctx.participante.cpf_cnpj,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((_ctx.participante.cpf_cnpj) = $event)),
                        _ctx.onChangeCpfCnpj
                    ],
                    tipo: "cpf-cnpj",
                    required: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
        ]),
        (_ctx.participante.tipo === 'F')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.participante.nome) = $event)),
                        type: "text",
                        class: "form-control",
                        required: ""
                    }, null, 512), [
                        [_vModelText, _ctx.participante.nome]
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_DatetimePicker, {
                        modelValue: _ctx.participante.data_nascimento,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.participante.data_nascimento) = $event)),
                        config: { format: 'DD/MM/YYYY', widgetPositioning: { vertical: 'top', horizontal: 'left' } },
                        required: ""
                    }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createVNode(_component_InputMasked, {
                        modelValue: _ctx.participante.celular,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.participante.celular) = $event)),
                        mask: "(##) #####-####",
                        required: ""
                    }, null, 8, ["modelValue"])
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.participante.tipo === 'J')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.participante.razao_social) = $event)),
                        type: "text",
                        class: "form-control",
                        required: ""
                    }, null, 512), [
                        [_vModelText, _ctx.participante.razao_social]
                    ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.participante.inscricao_estadual) = $event)),
                        type: "text",
                        class: "form-control",
                        required: ""
                    }, null, 512), [
                        [_vModelText, _ctx.participante.inscricao_estadual]
                    ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_component_InputMasked, {
                        modelValue: _ctx.participante.celular,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.participante.celular) = $event)),
                        mask: "(##) #####-####",
                        required: ""
                    }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("fieldset", null, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                                _hoisted_25,
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.participante.responsavel_nome) = $event)),
                                    type: "text",
                                    class: "form-control",
                                    required: ""
                                }, null, 512), [
                                    [_vModelText, _ctx.participante.responsavel_nome]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createVNode(_component_DatetimePicker, {
                                    modelValue: _ctx.participante.data_nascimento,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.participante.data_nascimento) = $event)),
                                    config: { format: 'DD/MM/YYYY' },
                                    required: ""
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createVNode(_component_InputMasked, {
                                    modelValue: _ctx.participante.responsavel_cpf,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.participante.responsavel_cpf) = $event)),
                                    mask: "###.###.###-##",
                                    required: ""
                                }, null, 8, ["modelValue"])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.participante.email) = $event)),
                    type: "email",
                    class: "form-control",
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.participante.email]
                ])
            ]),
            _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.participante.email_conf) = $event)),
                    type: "email",
                    class: "form-control",
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.participante.email_conf]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.participante.password) = $event)),
                    type: "password",
                    class: "form-control",
                    minlength: "6",
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.participante.password]
                ])
            ]),
            _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.participante.password_conf) = $event)),
                    type: "password",
                    class: "form-control",
                    minlength: "6",
                    required: ""
                }, null, 512), [
                    [_vModelText, _ctx.participante.password_conf]
                ])
            ])
        ])
    ]));
}
